import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CabsandTimesheetPendingPage } from './cabsand-timesheet-pending';

@NgModule({
  declarations: [
    CabsandTimesheetPendingPage,
  ],
  imports: [
    IonicPageModule.forChild(CabsandTimesheetPendingPage),
  ],
})
export class CabsandTimesheetPendingPageModule {}



// WEBPACK FOOTER //
// ./src/pages/cabsand-timesheet-pending/cabsand-timesheet-pending.module.ts